import { Injectable } from '@angular/core';

import { catchError } from 'rxjs/operators';

import { EMPTY, Observable } from 'rxjs';

import { HttpClientExtension } from '../../../common/services/http-client-extension.service';

import { AdviceBanner } from './login-main-info.model';

@Injectable({providedIn: 'root'})

export class LoginMainInfoService {

	constructor(
		private http: HttpClientExtension,
	) { }

	public getBanners(): Observable<Array<AdviceBanner>> {
		return this.http.get<Array<AdviceBanner>>('rest/common/pre-login/advices')
			.pipe(catchError(() => EMPTY));
	}

}
